module.exports = __webpack_public_path__ + "static/Logo-c68854a7b7919ed864c54b992b3e1388.png";